/**
 * @generated SignedSource<<07d6881ddf1227819109d699314ec66d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePaginatedMatters_matter$data = {
  readonly creator: {
    readonly id: string | null;
    readonly name: string;
  } | null;
  readonly dueDate: string | null;
  readonly externalReference: string | null;
  readonly id: string;
  readonly insertedAt: string;
  readonly number: number;
  readonly titleText: string;
  readonly " $fragmentSpreads": FragmentRefs<"AssigneesPreview__node" | "Status__status" | "Tags_tags">;
  readonly " $fragmentType": "usePaginatedMatters_matter";
};
export type usePaginatedMatters_matter$key = {
  readonly " $data"?: usePaginatedMatters_matter$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePaginatedMatters_matter">;
};
const node: ReaderFragment = function () {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePaginatedMatters_matter",
    "selections": [v0 /*: any*/, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleText",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueDate",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "insertedAt",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "concreteType": "_User",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [v0 /*: any*/, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalReference",
      "storageKey": null
    }, {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AssigneesPreview__node"
    }, {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Status__status"
    }, {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Tags_tags"
    }],
    "type": "_Matter",
    "abstractKey": null
  };
}();
(node as any).hash = "7a4a5d9fdd93f516a936dcf59c931d25";
export default node;